import styles from "./page.module.scss";
import { FaHome, FaPhoneAlt } from "react-icons/fa";
import { FaMapMarked } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Menubar } from "primereact/menubar";
import Logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();

  const NavRoutes = [
    {
      label: "Home",
      icon: <FaHome className="mr-2" />,
      command: () => navigate("/"),
    },
    {
      label: "About Us",
      icon: "pi pi-palette",
      command: () => navigate("/about"),
    },
    {
      label: "Services",
      icon: "pi pi-palette",
      command: () => navigate("/services"),
    },
    {
      label: "Employment",
      icon: "pi pi-palette",
      command: () => navigate("/employment"),
    },
    {
      label: "Request a Quote",
      icon: "pi pi-palette",
      command: () => navigate("/request-quote"),
    },
    {
      label: "PARS Check",
      icon: "pi pi-palette",
      items: [
        {
          label: "UPS",
          url: "/theming",
        },
        {
          label: "Livingston",
          url: "/unstyled",
        },
        {
          label: "Pacific Customs",
          url: "/unstyled",
        },
      ],
    },
    {
      label: "PAPS Check",
      icon: "pi pi-palette",
      items: [
        {
          label: "UPS",
          url: "/theming",
        },
        {
          label: "Deringer",
          url: "/theming",
        },
        {
          label: "Livingston",
          url: "/unstyled",
        },
        {
          label: "Pacific Customs",
          url: "/unstyled",
        },
      ],
    },
    {
      label: "Contact US",
      icon: "pi pi-palette",
      command: () => navigate("/contact-us"),
    },
  ];

  const InfoCard = ({ Icon, info }) => {
    return (
      <div className="flex align-items-center gap-3 m-3">
        <Icon />
        <p>{info}</p>
      </div>
    );
  };

  return (
    <div className={styles.headerContainer}>
      <div className="hidden lg:flex justify-content-between align-items-center">
        <img
          src={Logo}
          className={styles.logo}
          alt="Shah transport"
          width={180}
          height={100}
        />
        <div className="flex">
          <InfoCard Icon={FaPhoneAlt} info="(905)-216-3424" />
          <InfoCard Icon={MdEmail} info="dispatch@shahtransport.com" />
          <InfoCard
            Icon={FaMapMarked}
            info="5758 Dixie Rd, Mississauga ON L4W 1E7"
          />
        </div>
      </div>
      <div className="flex justify-content-center menu-container sticky top-0">
        <img
          src={Logo}
          className={styles.logo + "block lg:hidden"}
          alt="Shah transport"
          width={145}
          height={75}
        />
        <Menubar model={NavRoutes} className="justify-content-end border-none lg:justify-content-center w-full" />
      </div>
    </div>
  );
}
